import { useQuery, useQueries } from 'react-query';
import { AxiosResponse } from 'axios';
import { getSecuritiesComponentsById, getSecuritiesById } from 'services/securities';
import type { TGetSecuritiesComponentsById } from '@dekafvv/sharedfrontend';

export const useGetSecuritiesComponentsById = ({
    securityId,
    refetchOnMount = true,
    enabled = true,
}: {
    securityId: string;
  refetchOnMount?: boolean;
  enabled?: boolean;
}) => {
    const query = useQuery<
    AxiosResponse<TGetSecuritiesComponentsById>,
    null | { message: string },
    TGetSecuritiesComponentsById
  >({
      queryKey: ['getSecuritiesComponentsById', securityId],
      queryFn: () => getSecuritiesComponentsById(securityId).then(({ data }) => data),
      refetchOnWindowFocus: false,
      refetchOnMount,
      enabled,
  });

    return query;
};

export const useGetSecuritiesById = ({
    securitiesComponents,
    refetchOnMount = true,
}: {
  securitiesComponents: number[];
  refetchOnMount?: boolean;
  enabled?: boolean;
}) => {
    const query = useQueries(
        securitiesComponents.map((security) => ({
            queryKey: ['getSecuritiesById', security],
            queryFn: () => getSecuritiesById(security).then(({ data }) => data),
            enabled: !!securitiesComponents?.length,
            refetchOnWindowFocus: false,
            refetchOnMount,
        })),
    );

    return query;
};
